import type { JewelleryProductType } from '@/router'
import { assertNever } from '@/helpers'

// TODO replace with real icons
import iconNecklace from '@/assets/icons/jewellery_necklace.svg'
import iconBracelet from '@/assets/icons/jewellery_bracelet.svg'
import iconEarrings from '@/assets/icons/jewellery_earrings.svg'
import iconRing from '@/assets/icons/jewellery_ring.svg'

export type JewelleryProductTypeLabel<T extends JewelleryProductType> = {
    systemCode: T
    translation: { name: string }
    icon: { url: string } | null
}

export function getJewelleryProductTypeLabel<T extends JewelleryProductType>(
    systemCode: T
): JewelleryProductTypeLabel<T> {
    switch (systemCode) {
        case 'NECKLACE':
            return {
                systemCode,
                translation: {
                    name: 'Necklaces',
                },
                icon: { url: iconNecklace },
            }
        case 'BRACELET':
            return {
                systemCode,
                translation: {
                    name: 'Bracelets',
                },
                icon: { url: iconBracelet },
            }
        case 'EARRINGS':
            return {
                systemCode,
                translation: {
                    name: 'Earrings',
                },
                icon: { url: iconEarrings },
            }
        case 'RING':
            return {
                systemCode,
                translation: {
                    name: 'Rings',
                },
                icon: { url: iconRing },
            }
        default:
            return assertNever(systemCode, {
                systemCode,
                translation: {
                    name: 'Necklaces',
                },
                icon: { url: iconNecklace },
            })
    }
}
